import { httpClient } from '@/lib/api/httpClient';

export async function fetchDashboardData(employeeId, filterRange, viewMode = 'my', options = {}, signal) {
  return httpClient('/api/dashboard/data', {
    method: 'POST',
    signal,
    body: JSON.stringify({
      employeeId,
      filterRange,
      viewMode,
      ...options
    })
  });
}

export async function fetchDashboardClientStats(signal) {
  return httpClient('/api/dashboard/client-stats', {
    method: 'GET',
    signal
  });
}

export async function fetchDashboardClientTickets(clientId, signal) {
  return httpClient(`/api/dashboard/client-tickets/${encodeURIComponent(clientId)}`, {
    method: 'GET',
    signal
  });
}
